"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Image from "next/image";

type Card = {
  id: number;
  src: string;
};

const cards: Card[] = [
  { id: 1, src: "/next_assets/images/portfolio-services/animated-cards-step-1.png" },
  { id: 2, src: "/next_assets/images/portfolio-services/animated-cards-step-1.png" },
  { id: 3, src: "/next_assets/images/portfolio-services/animated-cards-step-1.png" },
];

const positions = [
  { x: -100, scale: 0.9, opacity: 0.4, rotate: -7, zIndex: 0 },
  { x: 0, scale: 1, opacity: 1, rotate: 0, zIndex: 2 },
  { x: 100, scale: 0.9, opacity: 0.4, rotate: 7, zIndex: 1 },
];

export default function CardRotator() {
  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prev) => (prev + 1) % 3);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {cards.map((card, index) => {
        const positionIndex = (index + step) % 3;
        const pos = positions[positionIndex];

        return (
          <motion.div
            key={card.id}
            animate={pos}
            transition={{
              duration: 0.9,
              ease: "easeInOut",
            }}
            className="absolute w-32 sm:w-40 h-auto rounded-xl shadow-lg"
          >
            <Image src={card.src} alt="card" width={200} height={250} className="w-32 sm:w-40 h-auto rounded-xl" />
          </motion.div>
        );
      })}
    </>
  );
}
